<script lang="ts">
  // A lightweight phone bezel that wraps a product "screen" mockup so the
  // built-in-code UI reads as a real app screenshot.
  let { label = "", children }: { label?: string; children: any } = $props();
</script>

<div class="phone" role="img" aria-label={label}>
  <div class="bezel">
    <span class="notch"></span>
    <div class="screen">
      {@render children()}
    </div>
  </div>
</div>

<style>
  .phone {
    width: 100%;
    max-width: 300px;
  }
  .bezel {
    position: relative;
    background: #11201a;
    border-radius: 38px;
    padding: 11px;
    box-shadow:
      var(--shadow),
      inset 0 0 0 1.5px rgba(255, 255, 255, 0.06);
  }
  .notch {
    position: absolute;
    top: 11px;
    left: 50%;
    transform: translateX(-50%);
    width: 38%;
    height: 18px;
    background: #11201a;
    border-radius: 0 0 12px 12px;
    z-index: 3;
  }
  .screen {
    position: relative;
    border-radius: 28px;
    overflow: hidden;
    background: var(--paper);
    aspect-ratio: 9 / 19;
  }
</style>
